import getActions from "./actionsPopupUtils";

const worker_housing_actions = (formName, isSubaccount) => {
  return getActions({ formName, isSubaccount, shared: true });
};

export default worker_housing_actions;
